import axios from 'axios';

const unsplash = axios.create({
    baseURL: 'https://api.unsplash.com/',
    headers: {
        Authorization: 'Client-ID 7JRbNedA8rBSvfxt3N0_D4t4oskM8NSmf3a2e0y5VWU'
    }    
});

export default unsplash;